import scrollTo from '../util/scrollTo';

export default {
  init() {
    // グロナビのクリックイベント
    $(document)
      .on('click', 'a[data-nav-link]', function (e) {
        e.preventDefault()
        const id = '#' + $(e.target).closest('a').attr('href').split('#')[1]
        const margin = $(id).attr('data-scroll-margin') || 0

        // SPハンバーガーメニューからリンクをクリックしたときは、ハンバーガーメニューを閉じ、bodyの.noscrollを削除する
        const globalHeader = document.getElementById('global_header')
        if (globalHeader.dataset.sp_menu_visibility === 'true') {
          globalHeader.dataset.sp_menu_visibility = 'false'
          $('body').removeClass('noscroll')
          scrollTo(id, margin, 1200)
        } else {
          scrollTo(id, margin, 1200)
        }
      })

    // ニュース詳細ページからグロナビをクリックして遷移してきた場合
    $(window).on('load', function () {
      let id = location.hash;
      if (id) {
        scrollTo(id, 0, 1200)
      }
    });

    // Accordion
    const show = document.getElementsByClassName('showPanel');
    const hide = document.getElementsByClassName('hidePanel');

    for (let i = 0; i < show.length; i++) {
      show[i].addEventListener('click', () => {
        show[i].parentElement.classList.add('is-active');
        const panel = show[i].nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    }

    for (let i = 0; i < hide.length; i++) {
      hide[i].addEventListener('click', () => {
        const panel = hide[i].parentElement;
        panel.parentElement.classList.remove('is-active');
        panel.style.maxHeight = null;
      });
    }

    // タブ切り替え機能
    const tabs = document.querySelectorAll('.yearlyPlan .tab');
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const targetId = this.getAttribute('data-tab');

        // すべてのタブとコンテンツから active クラスを削除
        tabs.forEach(t => t.classList.remove('active'));
        document.querySelectorAll('.yearlyPlan .tabContent').forEach(content => {
          content.classList.remove('active');
        });

        // クリックされたタブと対応するコンテンツに active クラスを追加
        this.classList.add('active');
        document.getElementById(targetId).classList.add('active');
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
